import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as questionnaireAdminActions from '../../ducks/questionnaire-admin'

import WopiInvitation from '../WopiInvitation'

function mapStateToProps(state) {
  return {
    isSendingInvitations: state.questionnaireAdmin.get('isSendingInvitations'),
    isGeneratingNoEmailInvitations: state.questionnaireAdmin.get('isGeneratingNoEmailInvitations'),
    noMoreWopiCredits: state.questionnaireAdmin.get('noMoreWopiCredits'),
    currentLanguage: state.account.get('currentLanguage'),
    currentAccount: state.account.get('currentAccount'),
    currentOrganisation: state.account.get('currentOrganisation')
  }
}

function mapDispatchToProps(dispatch) {
  const actions = bindActionCreators(questionnaireAdminActions, dispatch)

  return {
    onSendInvitations: actions.invite,
    onGenerateNoEmailInvitations: actions.generateNoEmailInvitations,
    onDismissNoMoreWopiCredits: actions.dismissNoMoreWopiCredits
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WopiInvitation)



// WEBPACK FOOTER //
// ./src/components/smart/WopiInvitationContainer.js